<template>
  <div>
    <div>
      <em class="font-14" :class="icon" />
      <span class="ml-2 font-14 font-weight-normal color-secondary-6">
        {{ title }}
      </span>
      <action-button
        v-if="hasEdit"
        i="fas fa-edit font-16 pl-2"
        min-width="10px"
        variant="outline-success ml-2 p-0"
        @click="$emit('on-edit')"
      />
    </div>
    <div class="d-flex">
      <div class="data ml-3 pl-1 font-20 text-break" :class="labelClass">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/shared/components/ActionButton';

export default {
  name: 'ResultHeaderItem',
  components: {
    ActionButton,
  },
  props: {
    icon: {
      type: String,
      default: () => '',
    },
    iconColor: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    value: {
      type: String,
      default: () => '',
    },
    hasEdit: {
      type: Boolean,
      default: () => false,
    },
    labelClass: {
      type: String,
      default: () => '',
    },
  },
};
</script>
